import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {sendVoiceInputRequest} from '../vuplex';
import {addRequestCases, requestDefaultState} from './reducerUtils';

const initialState = {
  googleApiKey: '',
  isToolOn: true,
  mapLocation: {
    center: {
      latitude: 0,
      longitude: 0,
    },
    radiusKm: 0,
    zoom: 0,
  },

  // TODO: pano: { panoId, location, panoIdIsApi2025 }
  panoId: '',
  panoIdIsApi2025: false,
  panoLocation: undefined, /*{
    latitude: 0,
    longitude: 0,
  }*/
  panoContributor: '',
  panoContributorIcon: '',
  panoContributorLink: '',

  permissions: {/* permA: 'permA', ... */},
  userId: '',
  voiceInput: requestDefaultState,
  world: { rules: null },
};

export const voiceInputRequest = createAsyncThunk(
  'inApp/voiceInputRequest',
  sendVoiceInputRequest,
);

export const inAppSlice = createSlice({
  name: 'inApp',
  initialState,
  reducers: {
    googleApiKeySet: (state, {payload: googleApiKey}) => {
      state.googleApiKey = googleApiKey;
    },
    isToolOnSet: (state, {payload: isOn}) => {
      state.isToolOn = isOn;
    },
    mapLocationSet: (state, {payload: {latitude, longitude, radius, zoom}}) => {
      state.mapLocation = {
        center: {latitude, longitude},
        radiusKm: radius,
        zoom,
      };
    },
    panoSet: (state, {payload: {
      contributor,
      contributorIcon,
      contributorLink,
      location,
      panoId,
      panoIdIsApi2025,
    }}) => {
      state.panoLocation = location && {
        latitude: location.LatitudeInDegrees,
        longitude: location.LongitudeInDegrees,
      };
      state.panoId = panoId;
      state.panoContributor = contributor;
      state.panoContributorIcon = contributorIcon;
      state.panoContributorLink = contributorLink;
      state.panoIdIsApi2025 = panoIdIsApi2025;
    },
    permissionsSet: (state, {payload: permissions}) => {
      state.permissions = permissions;
    },
    userIdSet: (state, {payload: userId}) => {
      state.userId = userId;
    },
    voiceInputClear: (state) => {
      state.voiceInput = requestDefaultState;
    },
    worldSet: (state, {payload}) => {
      state.world = payload;
    },
  },
  extraReducers: (builder) => { // https://redux-toolkit.js.org/api/createAsyncThunk#examples
    addRequestCases(builder, voiceInputRequest, 'voiceInput');
  }
});

export const {
  googleApiKeySet,
  isToolOnSet,
  mapLocationSet,
  panoSet,
  permissionsSet,
  userIdSet,
  voiceInputClear,
  worldSet,
} = inAppSlice.actions;

export default inAppSlice.reducer;
